import {v4 as uuidv4} from 'uuid';

export const extendedProducts = [
  // Nadellager
  {
    id: uuidv4(),
    manufacturer_sku: "NK25/20",
    normalized_sku: "nk2520",
    ean_gtin: "4003823000001",
    manufacturer: "INA",
    etim_class_code: "EC000032",
    specifications: {
      inner_diameter_mm: 25.0,
      outer_diameter_mm: 33.0,
      width_mm: 20.0,
      dynamic_load_rating_n: 19500,
      static_load_rating_n: 23000,
      limiting_speed_grease_rpm: 8500,
      needle_type: "Nadelkranz",
      cage_material: "Polyamid",
      attributes: {
        has_inner_ring: false,
        requires_hardened_shaft: true,
        contact_type: "line_contact"
      }
    },
    availability: "In Stock",
    updated_at: new Date().toISOString()
  },
  // Axiallager
  {
    id: uuidv4(),
    manufacturer_sku: "51205",
    normalized_sku: "51205",
    ean_gtin: "7316570000002",
    manufacturer: "SKF",
    etim_class_code: "EC000033",
    specifications: {
      inner_diameter_mm: 25.0,
      outer_diameter_mm: 47.0,
      height_mm: 15.0,
      dynamic_load_rating_n: 22400,
      static_load_rating_n: 36000,
      limiting_speed_grease_rpm: 4800,
      thrust_direction: "single",
      cage_material: "Steel",
      attributes: {
        load_direction: "axial_only",
        mounting_orientation: "horizontal_preferred"
      }
    },
    availability: "In Stock",
    updated_at: new Date().toISOString()
  },
  // Gehäuselager
  {
    id: uuidv4(),
    manufacturer_sku: "UCP205",
    normalized_sku: "ucp205",
    ean_gtin: "5012345000003",
    manufacturer: "Dodge",
    etim_class_code: "EC000034",
    specifications: {
      shaft_diameter_mm: 25.0,
      housing_type: "Pillow Block",
      bolt_centers_mm: 127,
      height_mm: 51.6,
      dynamic_load_rating_n: 14000,
      static_load_rating_n: 7850,
      housing_material: "Cast Iron",
      sealing: "Triple Seal",
      attributes: {
        self_aligning: true,
        mounting_bolts: 4,
        grease_fitting: true,
        shaft_attachment: "Set Screws"
      }
    },
    availability: "In Stock",
    updated_at: new Date().toISOString()
  },
  // Kegelrollenlager
  {
    id: uuidv4(),
    manufacturer_sku: "30205",
    normalized_sku: "30205",
    ean_gtin: "4012802000001",
    manufacturer: "Schaeffler (FAG)",
    etim_class_code: "EC000035",
    specifications: {
      inner_diameter_mm: 25.0,
      outer_diameter_mm: 52.0,
      width_mm: 16.25,
      dynamic_load_rating_n: 18300,
      static_load_rating_n: 16600,
      limiting_speed_grease_rpm: 8500,
      contact_angle_degrees: 13.5,
      cage_material: "Steel",
      attributes: {
        separable: true,
        preload_adjustable: true,
        mounting_arrangement: "back_to_back"
      }
    },
    availability: "In Stock",
    updated_at: new Date().toISOString()
  },
  // Miniaturlager
  {
    id: uuidv4(),
    manufacturer_sku: "625-2Z",
    normalized_sku: "6252z",
    ean_gtin: "7316570000003",
    manufacturer: "SKF",
    etim_class_code: "EC000030",
    specifications: {
      inner_diameter_mm: 5.0,
      outer_diameter_mm: 16.0,
      width_mm: 5.0,
      dynamic_load_rating_n: 1960,
      static_load_rating_n: 730,
      limiting_speed_grease_rpm: 32000,
      precision_class: "ABEC-7",
      seal_type: "2Z",
      cage_material: "Steel",
      attributes: {
        miniature_bearing: true,
        high_speed: true,
        low_torque: true
      }
    },
    availability: "In Stock",
    updated_at: new Date().toISOString()
  },
  // Weitere Dichtungen - FKM
  {
    id: uuidv4(),
    manufacturer_sku: "30x47x7-FKM",
    normalized_sku: "30x47x7fkm",
    ean_gtin: "4009026000001",
    manufacturer: "Freudenberg Sealing",
    etim_class_code: "EC002306",
    specifications: {
      inner_diameter_mm: 30.0,
      outer_diameter_mm: 47.0,
      width_mm: 7.0,
      material: "FKM",
      material_shore_hardness: 80,
      temperature_range: {
        min_celsius: -20,
        max_celsius: 200
      },
      design_features: {
        has_dust_lip: true,
        outer_case: "Metal",
        helix_direction: "Right"
      },
      compatibility_matrix: {
        mineral_oils: "Excellent",
        synthetic_oils: "Excellent",
        gasoline: "Excellent",
        acids_strong: "Excellent",
        ketones: "Poor",
        hot_water: "Good"
      }
    },
    availability: "In Stock",
    updated_at: new Date().toISOString()
  },
  // O-Ring
  {
    id: uuidv4(),
    manufacturer_sku: "O-Ring 25x3-NBR70",
    normalized_sku: "oring25x3nbr70",
    ean_gtin: "4009026000002",
    manufacturer: "Freudenberg Sealing",
    etim_class_code: "EC002307",
    specifications: {
      inner_diameter_mm: 25.0,
      cross_section_mm: 3.0,
      material: "NBR",
      material_shore_hardness: 70,
      temperature_range: {
        min_celsius: -30,
        max_celsius: 100
      },
      pressure_rating_bar: 200,
      surface_finish: "Standard",
      compatibility_matrix: {
        mineral_oils: "Excellent",
        hydraulic_oils: "Excellent",
        water: "Good",
        gasoline: "Poor",
        ozone: "Poor"
      }
    },
    availability: "In Stock",
    updated_at: new Date().toISOString()
  },
  // Zahnriemen
  {
    id: uuidv4(),
    manufacturer_sku: "HTD-8M-1200",
    normalized_sku: "htd8m1200",
    ean_gtin: "4003828000001",
    manufacturer: "Optibelt",
    etim_class_code: "EC001235",
    specifications: {
      profile: "HTD-8M",
      pitch_mm: 8.0,
      length_mm: 1200,
      width_mm: 20,
      teeth_count: 150,
      construction: {
        type: "Synchronous Belt",
        tensile_member: "Steel Cord",
        cover_material: "Chloroprene"
      },
      performance: {
        max_linear_speed_ms: 50,
        min_pulley_teeth: 18
      },
      attributes: {
        form_fit: true,
        no_slip: true,
        precise_timing: true
      }
    },
    availability: "In Stock",
    updated_at: new Date().toISOString()
  }
];